module.exports = __webpack_public_path__ + "static/img/p5.7ef831e7.png";